<template>
  <div>
    <!-- Header -->
    <div class="header d-flex align-items-center bg-gradient-dark py-5" style="min-height: 100vh;">
      <b-container>
        <b-row class="align-items-center">
          <!-- Logo Jata Negara dan Nama Sistem di Sebelah Kiri -->
          <b-col lg="6" md="6" class="d-flex flex-column align-items-center justify-content-center text-center">
            <img src="img/brand/jata-removebg-preview.png" alt="Jata Negara" style="width: 150px;" class="mb-4">
            <h1 class="text-white font-weight-bold">Sistem HEMAT</h1>
            <p class="text-light lead">
              Selamat Datang ke Sistem Pengurusan HEMAT
            </p>
          </b-col>

          <!-- Kotak Pendaftaran di Sebelah Kanan -->
          <b-col lg="5" md="6" sm="8" class="mx-auto ml-lg-5">
            <b-card no-body class="shadow-lg border-0"
              style="background-color: rgba(255, 255, 255, 0.85); border-radius: 30px !important;">
              <b-card-header class="bg-transparent text-center py-4" style="border-bottom: none;">
                <h3 class="mb-0">DAFTAR AKAUN</h3>
              </b-card-header>
              <b-card-body class="px-lg-4 py-lg-4">
                <p class="text-center mb-4" style="font-size: 1rem; font-weight: 300;">
                  Masukkan maklumat untuk mendaftar akaun anda.
                </p>
                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <base-input alternative class="mb-3" prepend-icon="ni ni-single-02" placeholder="No Kad Pengenalan"
                      name="noic" :rules="{ required: true, regex: /^[0-9]*$/ }" v-model="model.noic"
                      @input="model.noic = model.number.replace(/[^0-9]/g, '')"></base-input>

                    <!-- <base-input alternative class="mb-3" prepend-icon="ni ni-email-83" placeholder="Email"
                      name="email" :rules="{ required: true, email: true }" v-model="model.email"></base-input> -->

                    <base-input alternative class="mb-3" prepend-icon="ni ni-lock-circle-open" type="password"
                      placeholder="Kata Laluan" name="password" :rules="{ required: true, min: 6 }"
                      v-model="model.password"></base-input>

                    <div class="text-center">
                      <base-button type="primary" native-type="submit" class="btn btn-primary btn-block my-4">
                        Daftar
                      </base-button>
                    </div>
                  </b-form>
                </validation-observer>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>

import axios from 'axios';

  export default {
    name: 'register',
    data() {
      return {
        model: {
          // name: '',
          noic: '',
          // email: '',
          password: '',
          agree: false
        }
      }
    },
    methods: {
      onSubmit() {
        // this will be called only after form is valid. You can do an api call here to register users
      const url = 'http://localhost/hemat-b/api/register.php'; // Replace with your API endpoint
      const data = this.register_obj;
      var registerStatus = null;

      // console.log('Register Data:', data);

      axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
          },
        })
        .then((response) => {
          // Handle successful response
          registerStatus = response.data;

          // console.log('Response:', response.data);

        }).then(() => {
            // alert(registerStatus);
          if (registerStatus.status === 'success') {
            alert(registerStatus.message);
            // Redirect to the dashboard if login is successful
            this.$router.push('/profile');
          } else {
            // Handle unsuccessful login (e.g., show a message)

            alert(registerStatus.message || 'Login failed');
          }
        })
        .catch((error) => {
          // Handle errors
          // console.error('Error:', error.response ? error.response.data : error.message);
        });
      }
    },
  computed: {
    register_obj() {
      return this.model
    }
  },

  };
</script>
<style scoped>
.header {
  background: linear-gradient(87deg, #1e3a8a 0%, #1a2b5d 100%) !important;
  /* Menggunakan warna latar belakang yang sama seperti di login */
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.btn-primary {
  background: linear-gradient(87deg, #1e3a8a 0%, #1a2b5d 100%) !important;
  border: none !important;
}

.btn-primary:hover {
  background: linear-gradient(87deg, #1a2b5d 0%, #1e3a8a 100%) !important;
  border: none !important;
}

.text-light {
  color: rgba(255, 255, 255, 0.9) !important;
}

.rounded-lg {
  border-radius: 1.5rem;
}

.ml-lg-5 {
  margin-left: 3rem;
}
</style>
